import React from "react";
import { withTranslation } from 'react-i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Helmet } from "react-helmet";
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";

import Footer from "../Footer/FooterBottom";

class Prices extends React.Component {

    state = { showContact: false };

    showContact = () => {
        this.setState({
            showContact: true
        }, () => {
            window.Sprintful.initIframe();
        });
    }
    handleClose = () => {
        this.setState({
            showContact: false
        });
    }


    render() {
        const { t } = this.props;

        return (
            <>

                {
                    this.state.showContact ?
                        <Modal
                            size="xl"
                            show={this.state.showContact}
                            onHide={this.handleClose}
                            backdrop="static"
                            keyboard={false}
                            enforceFocus={false} >
                            <Modal.Header closeButton>
                                <Modal.Title> <i className="icon fa-light fa-handshake-angle"></i> {t('Pages.Register.Contact')} </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="widget">
                                    <div className="widget-body">
                                        <div
                                            className="sprintful-inline-widget"
                                            data-copy-parents-query="false"
                                            data-url="https://on.sprintful.com/alarabeyya?hide-logo=false&hide-message=false"
                                            style={{
                                                minWidth: '320px',
                                                height: '80vh'
                                            }}></div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        : ""
                }
                <Helmet>
                    <title>{t("PageHeader.Prices")} | {t('alarabeyya')}</title>
                    <script type="text/javascript" src="https://app.sprintful.com/widget/v1.js"></script>
                    <link href="https://app.sprintful.com/widget/v1.css" rel="stylesheet"></link>
                </Helmet>
                <section className="pos-rel padding-bottom padding-top d-flex oh align-items-center justify-content-center">
                    <div className="bottom-shape-left" style={{
                        right: "50px",
                        top: "calc(50% - 350px)"
                    }}>
                        <LazyLoadImage src="/assets/images/about/4275.png" style={{
                            transform: 'scaleX(-1)'
                        }} alt={`${t('alarabeyya')}`} />
                    </div>

                    <div className="container h-100">

                        <div className="row clearfix justify-content-center">

                            <div className="featured-block col-sm-6 " >
                                <div className="inner-box wow fadeInLeft animated" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                    <span className="border-one"></span>
                                    <span className="border-two"></span>
                                    <div className="icon-box d-flex justify-content-center flex-column cursor-pointer">
                                        <span className="icon"> <i className="fal fa-user-graduate display-4 text-white"></i></span>
                                    </div>
                                    <h5 className="cursor-pointer"> {t('Pages.Register.Single.title')}</h5>

                                    <div className="title mt-2" style={{
                                        fontSize: '18px'
                                    }}>
                                        يتم الدفع بشكل سنوي
                                        <h5 className="cursor-pointer m-0 p-0">
                                            10
                                            <i className="fal fa-dollar-sign"></i>
                                        </h5>
                                    </div>

                                    <Link to="/Register/Single" className={`custom-button primary-button mt-3`} >
                                        <span>
                                            ابدأ تجربتك المجانية الآن
                                        </span>
                                    </Link>

                                    <div className="list w-100 text-right">

                                        <ul>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                إمكانية تحميل أي ملف ورقي بالموقع
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح كل الملفات المحوسبة  لمدّة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح كل الألعاب المحوسبة لمدة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح جميع محتويات الموقع لمدّة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                صفر مخاطر: يمكنك إلغاء الاشتراك ببضع نقرات في أي وقت تريد خلال الشهر الأول ولن تدفع أي شيء.
                                                .
                                            </li>
                                        </ul>

                                    </div>

                                </div>
                            </div>


                            <div className="featured-block col-sm-6 " >
                                <div className="inner-box wow fadeInLeft animated" data-wow-delay="0ms" data-wow-duration="1500ms" >
                                    <span className="border-one"></span>
                                    <span className="border-two"></span>
                                    <div className="icon-box d-flex justify-content-center flex-column cursor-pointer">
                                        <span className="icon"> <i className="fal fa-school display-4 text-white"></i></span>
                                    </div>
                                    <h5 className="cursor-pointer"> {t('Pages.Register.School.title')}</h5>

                                    <div className="title mt-2" style={{
                                        fontSize: '18px'
                                    }}>
                                        يتم الدفع بشكل سنوي
                                        <h5 className="cursor-pointer m-0 p-0">
                                            10
                                            <i className="fal fa-dollar-sign"></i>
                                        </h5>
                                    </div>

                                    <div className="d-flex justify-content-around flex-wrap">
                                        <Link to="/Register/School" className={`custom-button primary-button mt-3 mr-1`} >
                                            <span>
                                                {t("Pages.Register.Now")}
                                            </span>
                                        </Link>
                                        <Link to="#" className={`custom-button info-button mt-3 mr-1`} onClick={() => this.showContact()}>
                                            <span>
                                                {t("Pages.Register.Contact")}
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="list w-100 text-right">

                                        <ul>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                إمكانية تحميل أي ملف ورقي بالموقع
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح كل الملفات المحوسبة  لمدّة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح كل الألعاب المحوسبة لمدة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح جميع محتويات الموقع لمدّة سنة
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                فتح حساب منفرد لكل معلم
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                امكانية بعث مهام محوسبة للطلاب (غير متوفرة بالاشتراكات الفرديّة)
                                                .
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-check mx-1 text-success"></i>
                                                صفر مخاطر: إذا لم تكن راضٍ لأي سبب، يمكنك استرجاع كامل المبلغ خلال 30 يومًا من الاشتراك
                                                .
                                            </li>
                                        </ul>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <Footer />
            </>
        );
    }
}

export default withTranslation('common')(Prices);